import { render, staticRenderFns } from "./FieldDate.vue?vue&type=template&id=21f63883&scoped=true&"
import script from "./FieldDate.vue?vue&type=script&lang=js&"
export * from "./FieldDate.vue?vue&type=script&lang=js&"
import style0 from "./FieldDate.vue?vue&type=style&index=0&id=21f63883&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f63883",
  null
  
)

export default component.exports